<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title">Lab Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p class="account_p">At this time, orders are being routed to designated labs. 
            Please check your order confirmation to find the mailing address of the lab for that order. 
            Check the Track Order page of the website for information about order status. Contact support if you have any questions.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [""]
  }
</script>



// WEBPACK FOOTER //
// LabInfo.vue?50e6e276